/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BedroomInputs */

const en_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedroom`)
};

const es_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dormitorio`)
};

const fr_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chambre`)
};

const de_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlafzimmer`)
};

const ja_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベッドルーム`)
};

const zh_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卧室`)
};

const ar_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرفة النوم`)
};

const id_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Tidur`)
};

const it_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera da Letto`)
};

const ru_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спальня`)
};

const pt_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarto`)
};

const ko_val_bedroom = /** @type {(inputs: Val_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`침실`)
};

/**
* | output |
* | --- |
* | "Bedroom" |
*
* @param {Val_BedroomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_bedroom = /** @type {((inputs?: Val_BedroomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BedroomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_bedroom(inputs)
	if (locale === "es") return es_val_bedroom(inputs)
	if (locale === "fr") return fr_val_bedroom(inputs)
	if (locale === "de") return de_val_bedroom(inputs)
	if (locale === "ja") return ja_val_bedroom(inputs)
	if (locale === "zh") return zh_val_bedroom(inputs)
	if (locale === "ar") return ar_val_bedroom(inputs)
	if (locale === "id") return id_val_bedroom(inputs)
	if (locale === "it") return it_val_bedroom(inputs)
	if (locale === "ru") return ru_val_bedroom(inputs)
	if (locale === "pt") return pt_val_bedroom(inputs)
	return ko_val_bedroom(inputs)
});